(() => {
  const enhance = (root = document) => {
    const money = [...root.querySelectorAll('[data-e2-money]')];
    if (root.matches?.('[data-e2-money]')) money.unshift(root);
    money.forEach(el => {
      const amount = Number(el.dataset.e2Money);
      if (!Number.isFinite(amount) || el.dataset.e2Money === '') return;
      const key = `${amount}:${el.dataset.currency}:${document.documentElement.lang}`;
      if (el.dataset.e2FormatKey === key) return;
      try {
        el.textContent = new Intl.NumberFormat(document.documentElement.lang || 'tr-TR', { style: 'currency', currency: el.dataset.currency || 'TRY' }).format(amount / 100);
        el.dataset.e2FormatKey = key;
      } catch {}
    });
  };
  enhance();
  const observer = new MutationObserver(records => {
    const roots = new Set();
    records.forEach(record => {
      if (record.type === 'attributes') roots.add(record.target);
      else record.addedNodes.forEach(node => { if (node.nodeType === 1) roots.add(node); });
    });
    roots.forEach(root => enhance(root));
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-e2-money', 'data-currency'] });
  document.addEventListener('toggle', event => {
    const details = event.target;
    if (!details.matches?.('.e2-header details')) return;
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(details.open));
    if (!details.open) return;
    document.querySelectorAll('.e2-header details[open]').forEach(other => { if (other !== details && !other.contains(details)) other.open = false; });
    if (details.matches('.e2-search-disclosure')) details.querySelector('input[type=search]')?.focus({ preventScroll: true });
  }, true);
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href="#ErkonProductDescription"]');
    if (!link) return;
    const description = document.getElementById('ErkonProductDescription');
    if (description) { description.open = true; description.querySelector('summary')?.focus({ preventScroll: true }); }
  });
  const desktop = matchMedia('(min-width: 990px)');
  desktop.addEventListener('change', event => { if (event.matches) document.querySelectorAll('.e2-mobile-menu[open]').forEach(menu => { menu.open = false; }); });
})();
